import { render, staticRenderFns } from "./fvSwitch.vue?vue&type=template&id=dfe65a72&lang=pug&"
import script from "./fvSwitch.vue?vue&type=script&lang=js&"
export * from "./fvSwitch.vue?vue&type=script&lang=js&"
import style0 from "./fvSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvSwitch.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvSwitch.vue
// module id = 138
// module chunks = 0 1